import React from "react";

import Feed from "../feed";

function Top(props) {
  return <Feed term="" filter="" sort="playCount" />;
}
export default Top;
